import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyALanc1p5eqlQq2WMTgwKDbiBBFIEXKlBs",
  authDomain: "prestige-capital-wins.firebaseapp.com",
  projectId: "prestige-capital-wins",
  storageBucket: "prestige-capital-wins.appspot.com",
  messagingSenderId: "604920724258",
  appId: "1:604920724258:web:afcf5fef1ca4a40039437b",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDtmNsjSnruKS6ZCs3jwqec0QMqGqGKQWk",
//   authDomain: "finance-v2-e1682.firebaseapp.com",
//   projectId: "finance-v2-e1682",
//   storageBucket: "finance-v2-e1682.appspot.com",
//   messagingSenderId: "133386766551",
//   appId: "1:133386766551:web:e0236afa4a4dc881e20892",
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
